import { errorLogger } from '../services/errorLogger';

export interface ApiError {
  status: number;
  message: string;
  details?: any;
}

export class ErrorHandler {
  static handleApiError(error: any): string {
    let errorMessage = 'Ocorreu um erro inesperado. Tente novamente.';
    let shouldLog = true;

    // Se é uma resposta de erro da API
    if (error.response) {
      const { status, data } = error.response;
      
      switch (status) {
        case 400:
          errorMessage = 'Dados inválidos. Verifique as informações e tente novamente.';
          shouldLog = false; // Erro do usuário, não precisa logar
          break;
          
        case 401:
          errorMessage = 'Email/apelido ou senha incorretos. Verifique suas credenciais.';
          shouldLog = false; // Erro de autenticação comum
          break;
          
        case 403:
          errorMessage = 'Acesso negado. Você não tem permissão para realizar esta ação.';
          shouldLog = true;
          break;
          
        case 404:
          errorMessage = 'Recurso não encontrado.';
          shouldLog = true;
          break;
          
        case 422:
          errorMessage = 'Dados inválidos. Verifique as informações fornecidas.';
          shouldLog = false; // Erro de validação
          break;
          
        case 429:
          errorMessage = 'Muitas tentativas. Aguarde um momento e tente novamente.';
          shouldLog = true;
          break;
          
        case 500:
        case 502:
        case 503:
        case 504:
          errorMessage = 'Estamos enfrentando instabilidades no momento. Por favor, tente novamente mais tarde.';
          shouldLog = true;
          break;
          
        default:
          if (status >= 500) {
            errorMessage = 'Estamos enfrentando instabilidades no momento. Por favor, tente novamente mais tarde.';
          } else if (status >= 400) {
            errorMessage = 'Erro na requisição. Tente novamente.';
          }
          shouldLog = true;
      }

      // Log do erro se necessário
      if (shouldLog) {
        errorLogger.error(`API Error ${status}`, {
          status,
          data,
          url: error.config?.url,
          method: error.config?.method,
          originalError: error
        });
      }
    } 
    // Se é um erro de rede
    else if (error.request) {
      errorMessage = 'Erro de conexão. Verifique sua internet e tente novamente.';
      errorLogger.error('Network Error', {
        request: error.request,
        originalError: error
      });
    } 
    // Se é um erro de configuração
    else {
      errorMessage = 'Erro de configuração. Tente recarregar a página.';
      errorLogger.error('Configuration Error', {
        message: error.message,
        originalError: error
      });
    }

    return errorMessage;
  }

  static handleValidationError(errors: any): string {
    if (typeof errors === 'string') {
      return errors;
    }

    if (Array.isArray(errors)) {
      return errors.join(', ');
    }

    if (typeof errors === 'object') {
      const errorMessages = Object.values(errors).flat();
      return errorMessages.join(', ');
    }

    return 'Dados inválidos. Verifique as informações fornecidas.';
  }

  static handleGenericError(error: any): string {
    errorLogger.error('Generic Error', {
      message: error.message,
      stack: error.stack,
      originalError: error
    });

    return 'Ocorreu um erro inesperado. Tente novamente.';
  }

  static isNetworkError(error: any): boolean {
    return !error.response && error.request;
  }

  static isServerError(error: any): boolean {
    return error.response && error.response.status >= 500;
  }

  static isClientError(error: any): boolean {
    return error.response && error.response.status >= 400 && error.response.status < 500;
  }
}
